































































import CurrencyMarkup from "@/store/entities/currencyMarkup";
import ExchangeRate from "@/store/entities/exchangeRate";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ExchangeRates extends Vue {
  mockData: any[] = [];
  headers: any[] = [];
  exchangeDate: Date = null;
  breadcrumbsItems: any[] = [];
  exchangeRates: ExchangeRate[] = [];
  currencyMarkups: CurrencyMarkup[] = [];
  created() {
    this.getExchangeRates();
    this.getCurrencyMarkups();

    (this.headers = [
      {
        text: "Para Birimi",
        align: "start",
        filterable: false,
        value: "currency",
      },
      { text: "Oran", value: "rate" },
      { text: "Hesaplanan Oran", value: "calculatedRate" },
      { text: "Tarih", value: "date" },
    ]),
      (this.mockData = [
        {
          currency: "TRY",
          rate: "1.00",
          calculatedRate: "1.00",
          date: "05.03.2021",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Kur Oranları", disabled: true },
    ];
  }

  async getExchangeRates() {
    await this.$store.dispatch({
      type: "exchangeRate/getExchangeRates",
    });

    this.exchangeRates = this.$store.state.exchangeRate.list;
  }
  async addCurrencyMarkup() {
    await this.$store.dispatch({
      type: "exchangeRate/addCurrencyMarkup",
      data:this.currencyMarkups
    });
    await this.getExchangeRates();
    Vue.$toast.success("Kurlar Güncellendi");
  }
  
  async getCurrencyMarkups() {
    var result =  await this.$store.dispatch({
      type: "exchangeRate/getCurrencyMarkups",
    });

    this.currencyMarkups =result;
   
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }
}
